import { Link as RouterLink, useLocation } from 'react-router-dom';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';

const BOOK_GREEN = '#00c853';
const BOOK_GREEN_DARK = '#00a844';

export default function BookFab() {
  const { pathname } = useLocation();
  const hidden = pathname.startsWith('/booking');

  if (hidden) return null;

  return (
    <Tooltip title="Book a court" placement="left">
      <Fab
        component={RouterLink}
        to="/booking"
        color="primary"
        aria-label="Book a court"
        sx={{
          position: 'fixed',
          right: { xs: 16, sm: 24 },
          bottom: { xs: 16, sm: 24 },
          zIndex: (theme) => theme.zIndex.speedDial,
          bgcolor: BOOK_GREEN,
          color: '#fff',
          boxShadow: '0 6px 20px rgba(0, 200, 83, 0.45)',
          '&:hover': {
            bgcolor: BOOK_GREEN_DARK,
            boxShadow: '0 8px 24px rgba(0, 200, 83, 0.55)',
          },
        }}
      >
        <EventAvailableRoundedIcon sx={{ fontSize: 28 }} />
      </Fab>
    </Tooltip>
  );
}
